import { AxiosResponse } from 'axios';

import CustomHttpClient from '../customHttpClient';

import { getError } from '../../utils';
import userHelper from '../../utils/userHelper';

import {
  APConstancyWithoutClauseServiceRequest,
  APConstancyWithoutClauseServiceResponse,
  Base64,
  UserInformation,
} from '../../interfaces/services';
import { EndorsementPolicyDocumentRequest, EndorsementPolicyDocumentResponse } from '../../interfaces/services/get-endorsement-policy-document-service';
import { DocumentUploadServiceRequestParams, DocumentUploadServiceResponse } from '../../interfaces/services/post-send-claim-documents-service';
import { ComplaintPdfServiceRequest, ComplaintPdfServiceResponse } from '../../interfaces/services/complaint-pdf-service';
import { GetCertificateWithoutOverdueDebtRequest, GetCertificateWithoutOverdueDebtResponse } from '../../interfaces/services/get-certificate-without-overdue-service';
import { GetProofCivilLiabilityCoveragePostersRequest, GetProofCivilLiabilityCoveragePostersResponse } from '../../interfaces/services/get-proof-civilLiabilityCoveragePosters';
import { GetBoilerCoverageRequest, GetBoilerCoverageResponse } from '../../interfaces/services/get-boiler-coverage-service';
import { GetConsortiumCoverageRequest, GetConsortiumCoverageResponse } from '../../interfaces/services/get-consortium-coverage-service';
import { GetHomeCombinedFamilyCovertureRequest, GetHomeCombinedFamilyCovertureResponse } from '../../interfaces/services/get-combined-family-home-coverture-service';
import { GetCommerceCoverageRequest, GetCommerceCoverageResponse } from '../../interfaces/services/get-commerce-coverage-service';
import { GetCollectiveLifeCoverageRequest, GetCollectiveLifeCoverageResponse } from '../../interfaces/services/get-collective-life-coverage-service';
import { APConstancyWithClauseServiceRequest, APConstancyWithClauseServiceResponse } from '../../interfaces/services/ap-constancy-with-clause-service';
import { DocumentCarCoverageResponse, DocumentCarCoverageRequest } from '../../interfaces/services//post-document-car-coverage-service';
import { CirculationCardPdfServiceRequest, CirculationCardPdfServiceResponse } from '../../interfaces/services/circulation-card-pdf-service';
import { PayedFeeDocumentRequest, PayedFeeDocumentResponse } from '../../interfaces/services/get-payed-fee-document';
import { FilenetDocumentRequest, FilenetDocumentResponse } from '../../interfaces/services/get-document-service';
import { CompensationReceiptPdfRequest, CompensationReceiptPdfResponse } from '../../interfaces/services/compensation-receipt-pdf-service';
import { getEnrollmentAndTerminationOfInsuredDocumentRequest } from '../../interfaces/services/enrollment-and-termination-document-request';
import { APConstancyWithFirstBeneficiaryServiceRequest, APConstancyWithFirstBeneficiaryServiceResponse } from '../../interfaces/services/ap-constancy-with-first-beneficiary-clause-service';
import { CoverageConstancyServiceRequest, CoverageConstancyServiceResponse } from '../../interfaces/services/coverage-constancy-request';
import { PolicyOverdueDebtPDFRequest } from '../../interfaces/services/policy-overdue-debt-pdf-request';
import { DebitBankRejectionsPDF } from '../../interfaces/services/debit-bank-rejections-pdf-request';
import { FranchiseLettereResponse, FranchiseLetterRequest } from '../../interfaces/services/get-franchise-letter-service';
import { PolicyDocumentRequest, PolicyDocumentServiceResponse } from '../../interfaces/services/policy-document-request';
const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });

const DocumentsService = {
  baseUrl: 'productores',

  async getApConstancyWithClauseInPDF(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaApConClausula';
    const params = { ...data };

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        params
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
async getApWithPrimaryBeneficiaryClausePDF(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaAPBeneficiarioPrimerTermino';
    const params = { ...data };

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        params
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
   async getApConstancyWithoutClauseInPDF(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaApSinClausula';
    const params = { ...data };

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        params
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getEndorsementPolicyInPDF(
    data: EndorsementPolicyDocumentRequest
  ): Promise<AxiosResponse<EndorsementPolicyDocumentResponse, any>> {
    const url = 'descargarPolizaEndoso';

    try {
      const response = await customHttpClient.post<EndorsementPolicyDocumentResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getDocumentFromS3(
    data: FilenetDocumentRequest,
    showMessage: boolean
  ): Promise<AxiosResponse<FilenetDocumentResponse, any>> {
    const url = 'descargarPolizaEndoso';

    try {
      const response = await customHttpClient.post<FilenetDocumentResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      if(showMessage)
        throw new Error(getError(error));
      throw new Error();
    }
  },

  async getComplaintPDF(data: ComplaintPdfServiceRequest): Promise<AxiosResponse<ComplaintPdfServiceResponse, any>> {
    const url = 'documents/denuncia';

    try {
      const response = await customHttpClient.post<ComplaintPdfServiceResponse>(url, data );
      return response;

    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getCertificateOfOverdueDebt(
    data: GetCertificateWithoutOverdueDebtRequest
  ): Promise<AxiosResponse<GetCertificateWithoutOverdueDebtResponse, any>> {
    const url = 'documents/certificadoPolizaSinDeudaVencida';

    try {
      const response = await customHttpClient.post<GetCertificateWithoutOverdueDebtResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async sendReportFeePaidDocument(
    requestParams: DocumentUploadServiceRequestParams
  ): Promise<AxiosResponse<DocumentUploadServiceResponse>> {
    const url = 'uploadReciboPagoTransferencia';

    try {
      const response =
        await customHttpClient.post<DocumentUploadServiceResponse>(
          url,
          requestParams
        );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getCertificateOfProofCivilLiabilityCoveragePosters(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documentos/constanciaCoberturaRcCarteles';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getBoilerCoverageDocument(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaRcCalderasConsorcio';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getConsortiumCoverageDocument(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaConsorcio';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getHomeCombinedFamilyDocument(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaCombinadoFamiliar';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getCommerceCoverageDocument(data: CoverageConstancyServiceRequest): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaComercio';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getEnrollmentAndTerminationOfInsuredDocument(data: getEnrollmentAndTerminationOfInsuredDocumentRequest): Promise<AxiosResponse<GetCollectiveLifeCoverageResponse, any>> {
    const url = 'certificadoAltaBajaNomina';

    try {
      const response = await customHttpClient.post<GetCollectiveLifeCoverageResponse>(
        url,
        data
      );

      return response;
    } catch (error) {      
      throw new Error(getError(error));
    }
  },
  async getCollectiveLifeCoverageDocument(data: CoverageConstancyServiceRequest): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaVidaColectivo';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
  async getDocumentCarCoverage(
    data: CoverageConstancyServiceRequest
  ): Promise<AxiosResponse<CoverageConstancyServiceResponse, any>> {
    const url = 'documents/constanciaCoberturaVehiculos';

    try {
      const response = await customHttpClient.post<CoverageConstancyServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getCirculationCardPdfOnTheFly(data: CirculationCardPdfServiceRequest): Promise<AxiosResponse<CirculationCardPdfServiceResponse, any>> {
    const url = 'documents/tarjetaDeCirculacion';

    try {
      const response = await customHttpClient.post<CirculationCardPdfServiceResponse>(url, data );
      return response;

    } catch (error) {
      throw new Error(getError(error));
    }
  }, async getPayedFeeDocument(
    data: PayedFeeDocumentRequest
  ): Promise<AxiosResponse<PayedFeeDocumentResponse, any>> {
    const url = 'documents/descargarReciboCuota';

    try {
      const response = await customHttpClient.post<PayedFeeDocumentResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getCompensationReceiptPdfOnTheFly(data: CompensationReceiptPdfRequest): Promise<AxiosResponse<CompensationReceiptPdfResponse, any>> {
    const url = 'documents/generarReciboIndemnizacion';

    try {
      const response = await customHttpClient.post<CompensationReceiptPdfResponse>(url, data );
      return response;

    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getPolicyOverdueDebtPdf(data: PolicyOverdueDebtPDFRequest): Promise<AxiosResponse<Base64, any>> {
    const url = 'documents/certificadoPolizaConDeudaVencida';

    try {
      const response = await customHttpClient.post<Base64>(url, data );
      return response;

    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getRejectionDebitBancaryCertificatePdf(data: DebitBankRejectionsPDF ): Promise<AxiosResponse<Base64, any>> {
    const url = 'documents/certificadoRechazoDebitosBancarios';

    try {
      const response = await customHttpClient.post<Base64>(url, data );
      return response;

    } catch (error) {
      throw new Error(getError(error));
    }
  },
   async getFranchiseLetter(data: FranchiseLetterRequest): Promise<AxiosResponse<FranchiseLettereResponse, any>> {
    const url = 'documents/generarCartaFranquicia';

    try {
      const response = await customHttpClient.post<FranchiseLettereResponse>(url, data );
      return response;

    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getPolicyDocumentOnTheFly(data: PolicyDocumentRequest): Promise<AxiosResponse<PolicyDocumentServiceResponse, any>> {
    const url = 'documents/generarPolizaPDF';

    try {
      const response = await customHttpClient.post<PolicyDocumentServiceResponse>(
        url,
        data
      );

      return response;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

};

export default DocumentsService;